import React from 'react'

export const FAQ_DATA = [
  {
    id: 'channels-affected',
    question: 'What channels are affected?',
    answer: (
      <div>
        <p style={{ marginBottom: '12px' }}>
          The following NBCU channels are no longer available on Fubo:
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', fontSize: '14px' }}>
          <div>
            <strong style={{ color: '#1e293b' }}>Local Channels:</strong>
            <p style={{ marginLeft: '16px', marginTop: '4px' }}>
              NBC Local Affiliates, Telemundo Local/National
            </p>
          </div>
          <div>
            <strong style={{ color: '#1e293b' }}>Regional Sports Channels:</strong>
            <p style={{ marginLeft: '16px', marginTop: '4px' }}>
              NBC Sports 4K, NBC Sports Bay Area, NBC Sports Bay Area Plus, NBC Sports Boston, NBC
              Sports California, NBC Sports California Plus, NBC Sports California Plus 3, NBC
              Sports Philadelphia, NBC Sports Philadelphia Plus
            </p>
          </div>
          <div>
            <strong style={{ color: '#1e293b' }}>National Channels:</strong>
            <p style={{ marginLeft: '16px', marginTop: '4px' }}>
              American Crimes, Bravo, Bravo Vault, Caso Cerrado, CNBC, CNBC World, Cozi, Dateline
              24/7, E! Entertainment Television, E! Keeping Up, Golf Channel, GolfPass, LX Home,
              Million Dollar Listing Vault, MS Now, NBC NOW, NBC Sports NOW, NBC Universo, True
              CRMZ, New England Cable News, Noticias Telemundo Ahora, Oxygen True Crime, Oxygen True
              Crime Archives, Real Housewives Vault, SNL Vault, Telemundo Accion, Telemundo al Dia,
              The Golf Channel, Today All Day, Universal Movies, USA Network
            </p>
          </div>
        </div>
      </div>
    ),
  },
  {
    id: 'why-dark',
    question: 'Why did the channels go dark?',
    answer: (
      <p>
        NBC Universal (NBCU) removed their channels at 5pm ET on November 21, 2025. They are using
        their powerful sports content to force us to pay above-market economics and force you to pay
        for non-sports content you don't want.
      </p>
    ),
  },
  {
    id: 'watch-content',
    question: 'Can I still watch NBCU content?',
    answer: (
      <div>
        <p style={{ marginBottom: '12px' }}>
          <strong>Option 1: Peacock (Covered by Your Credit)</strong>
        </p>
        <p style={{ marginBottom: '16px', fontSize: '14px' }}>
          You can choose to subscribe to Peacock Premium to watch NBCU content. Your automatic $15
          credit can help cover that cost. With Peacock, you can continue watching NBCU sports
          content while we work to bring these channels back at fair rates.
        </p>
        <p style={{ marginBottom: '12px' }}>
          <strong>Option 2: Hulu + Live TV (Complete Bundle)</strong>
        </p>
        <p style={{ fontSize: '14px' }}>
          If you want access to the complete bundle of live TV channels including NBCU networks,
          Hulu + Live TV is an alternative option.
        </p>
      </div>
    ),
  },
  {
    id: 'apply-credit',
    question: 'Do I need to apply for the $15 credit?',
    answer: (
      <p>
        No. The $15 credit will be automatically applied on or after Dec. 1, 2025, if the blackout
        continues. You do not need to contact customer support.
      </p>
    ),
  },
  {
    id: 'dvr-recordings',
    question: 'What happens to my Cloud DVR recordings of NBCU programming?',
    answer: (
      <p>
        Any Cloud DVR recordings you have of NBCU programming will remain on your account until they
        expire or you choose to delete them.
      </p>
    ),
  },
  {
    id: 'still-worth-it',
    question: 'Is Fubo still worth it without NBCU?',
    answer: (
      <p>
        Absolutely. Fubo remains the best streaming service for sports, news and entertainment. Fubo
        still carries some of the most popular channels including your local ABC, CBS, and FOX
        affiliate stations along with ESPN, Fox News, NFL Network and hundreds of other popular
        channels. Fubo is still the leader in local sports, carrying the widest selection of
        Regional Sports Networks (RSNs) to ensure you don’t miss your home team’s games—coverage
        that other streaming services do not include. Finally, Fubo has just added ESPN Unlimited to
        your subscription for free.
      </p>
    ),
  },
  {
    id: 'how-to-help',
    question: 'What can I do to help?',
    answer: (tweetText) => (
      <p>
        Make your voice heard.{' '}
        {tweetText && (
          <a
            href={`https://twitter.com/intent/tweet?text=${tweetText}`}
            target="_blank"
            rel="noreferrer"
            style={{ color: '#3b82f6', textDecoration: 'underline' }}
          >
            Contact NBCU via social media.
          </a>
        )}{' '}
        Tell them to stop blocking your choices and stop forcing Fubo to pay for channels you don't
        want.{' '}
      </p>
    ),
  },
]
